// extracted by mini-css-extract-plugin
export var modal = "_bg-0";